import axios from '@/config/httpConfig'

export function getvCode() {
    return axios.get('/topsystem/vcode')
}

export function getSmsvCode(data) {
    return axios.agentPost('/topsystem/smsvcode', data)
}

export function login(data) {
    return axios.agentPost('/user/mobile/sms', data)
}

export function getToken(data) {
    return axios.agentPost('/api/oauth2/access_token', data)
}

export function getDepartment() {
    return axios.get('/account_user/department')
}

//获取字典数据
export function getDict(_dicttype) {
    return axios.get('/dict/' + _dicttype)
}
//判断单位隶属
export function getSubjection(collegeid, field, year) {
    return axios.get('/agreement_record/' + collegeid + '/formfield/' + field + '/required?year=' + year)
}
//上传营业执照
export function uploadImg(data) {
    return axios.post('/agreement_record/department/upload/private/file', data)
        // return axios.post('/department/uploadimage/app', data)

}
//上传企业电子章
export function uploadChapter(data) {
    return axios.post('/agreement_record/department/upload/electronic_chapter', data)
}
//企业提交签约信息
export function signSubmit(id, data) {
    return axios.post('/agreement_record/department/submit/' + id, data)
}
//企业提交签约信息
export function getSignInfo(num) {
    return axios.get('/agreement_record/number/' + num)
}
export function getSignchip(su_number) {
    return axios.get('agreement_record/' + su_number + '/tips')
}
//获取签约信息
export function getSignDetail(su_number) {
    return axios.get('/agreement_record/number/' + su_number)
}
//获取高校信息
export function getCollege(collegeid) {
    return axios.get('/college/' + collegeid + '/public')
}
//获取高校配置信息
export function getCollegeSetting(collegeid) {
    return axios.get('/agreement_record/' + collegeid + '/tips')
}
//同意签约
export function acceptSign(num, data) {
    return axios.post('/agreement_record/department/accept/' + num, data)
}
//判断是否可以签约
export function isSign(num) {
    return axios.get('/agreement_record/check/' + num)
}

//验证社会统一信用代码
export function CheckCode(data) {
    return axios.post('/topsystem/formatvalidation', data)
}